import { FC, SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  size: number
  color?: string
}

export const PlusAddIcon: FC<Props> = ({
  size,
  color = '#D9D9D9',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="17" width="36" height="3" rx="1.5" fill={color} />
      <rect
        x="17"
        y="36"
        width="36"
        height="3"
        rx="1.5"
        transform="rotate(-90 17 36)"
        fill={color}
      />
    </svg>
  )
}
